import { userService } from '@/services'

let initialState = {
  isAuthenticated: false,
  username: null,
  jwt: null,
  sessionTimedOut: false
}

export default {
  state: () => initialState,
  mutations: {
    LOGIN(state, userData) {
      if (userData.response.jwt) {
        state.isAuthenticated = true
        state.username = userData.user.username
        state.jwt = userData.response.jwt
      }
    },
    LOGOUT() {
      localStorage.clear()
    },
    SESSION_TIMEOUT(state) {
      state.sessionTimedOut = true
    },
    SET_TOKEN(state, jwt) {
      state.jwt = jwt
    },
    RESET(state) {
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },
  actions: {
    async loginUser({ commit, dispatch }, user) {
      const response = await userService.login(user)
      commit('LOGIN', { user, response })
      dispatch('setOrganizationByLoginResponse', response).then(() => {
        dispatch('getWhiteLabelAssets', false, { root: true })
      })
      return response
    },
    async loginUserKeycloak({ commit, dispatch }, user) {
      const response = await userService.keycloakLogin(user)
      commit('LOGIN', { user, response })
      dispatch('setOrganizationByLoginResponse', response)
      return response
    },
    async setUserData({ commit }, { user, response }) {
      commit('LOGIN', { user, response })
    },
    setToken({ commit }, jwt) {
      commit('SET_TOKEN', jwt)
    },
    async logoutUser({ commit, getters }) {
      const username = getters?.username
      try {
        userService.logout({ username }).catch(error => {
          console.error('Logout failed:', error?.message || error)
        })
        commit('LOGOUT')
        commit('RESET')
        return true
      } catch (error) {
        console.error('Logout failed:', error?.message || error)
        throw error
      }
    },
    sessionTimeOut({ commit }) {
      setTimeout(() => {
        commit('SESSION_TIMEOUT')
      }, 1000)
    }
  },
  getters: {
    isAuthenticated: state => {
      return state.isAuthenticated
    },
    jwt: state => {
      return state.jwt
    },
    username: state => {
      return state.username
    },
    sessionTimedOut: state => {
      return state.sessionTimedOut
    }
  }
}
